import $ from 'jquery';
import mediator from './mediator';

var configureHeroBG = function configureHeroBG() {
  var screenSize = window.cigna.screen.breakpoint;
  $('.hero-white-left-box').removeClass('d-none');
  $('.hero-white-center-box').removeClass('d-none');

  switch (screenSize) {
    case 'xs':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-xs-bg'), ")"),
        height: '144px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-xs-bg'), ")"),
        height: '500px'
      });
      $('.hero-long-intro').css('background-size', "100% calc(".concat($('.long-intro-content').outerHeight(true), "px + ").concat($('.long-intro-accent').outerHeight(true), "px + 184px + 1.5rem)"));
      $('.hero-white-left-box').css({
        left: '0px'
      });
      $('.hero-white-center-box').css({
        left: 'calc((100% - 83% + 2rem) / 2)'
      });
      $('.hero-full-width-photo').css('margin-bottom', '46rem');
      break;

    case 'sm':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-sm-bg'), ")"),
        height: '192px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-sm-bg'), ")"),
        height: '292px'
      });
      $('.hero-long-intro').css('background-size', "100% calc(".concat($('.long-intro-content').outerHeight(true), "px + ").concat($('.long-intro-accent').outerHeight(true), "px + 284px + 3rem)"));
      $('.hero-white-left-box').css({
        left: '0px'
      });
      $('.hero-white-center-box').css({
        left: 'calc((100% - 544px + 2rem) / 2)'
      });
      $('.hero-full-width-photo').css('margin-bottom', '15rem');
      break;

    case 'md':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-md-bg'), ")"),
        height: '248px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-md-bg'), ")"),
        height: '348px'
      });
      $('.hero-white-left-box').css({
        left: 'calc((100% - 724px + 2rem) / 2)'
      });
      $('.hero-white-center-box').css({
        left: 'calc((100% - 724px + 2rem) / 2)'
      });
      $('.hero-full-width-photo').css('margin-bottom', "calc((".concat($('.hero-white-left-box').outerHeight(true), "px - (248px - 2rem)) + 4rem)"));
      break;

    case 'lg':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-lg-bg'), ")"),
        height: '284px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-lg-bg'), ")"),
        height: '384px'
      });
      $('.hero-white-left-box').css({
        left: 'calc((100% - 964px + 2rem) / 2)'
      });
      $('.hero-white-center-box').css({
        left: 'calc((100% - 964px + 2rem) / 2)'
      });
      $('.hero-homepage .hero-white-left-box').css('max-width', 'calc((100% - (100% - 1144px + 1rem)) * .4166)');
      $('.hero-full-width-photo').css('margin-bottom', "calc((".concat($('.hero-white-left-box').outerHeight(true), "px - (284px - 2rem)) + 4rem)"));
      break;

    case 'xl':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-lg-bg'), ")"),
        height: '360px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-lg-bg'), ")"),
        height: '460px'
      });
      $('.hero-white-left-box').css({
        left: 'calc((100% - 1144px + 2rem) / 2)'
      });
      $('.hero-white-center-box').css({
        left: 'calc((100% - 1144px + 2rem) / 2)'
      });
      $('.hero-homepage .hero-white-left-box').css('max-width', 'calc((100% - (100% - 1144px + 1rem)) * .4166)');
      $('.hero-full-width-photo').css('margin-bottom', "calc((".concat($('.hero-white-left-box').outerHeight(true), "px - (360px - 3rem)) + 4.5rem)"));
      break;

    default:
      break;
  }
};

export var initialHeroBG = function initialHeroBG() {
  var screenSize = window.cigna.screen.breakpoint;

  switch (screenSize) {
    case 'xs':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-xs-bg'), ")"),
        height: '144px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-xs-bg'), ")"),
        height: '500px'
      });
      break;

    case 'sm':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-sm-bg'), ")"),
        height: '192px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-sm-bg'), ")"),
        height: '292px'
      });
      break;

    case 'md':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-md-bg'), ")"),
        height: '248px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-md-bg'), ")"),
        height: '348px'
      });
      break;

    case 'lg':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-lg-bg'), ")"),
        height: '284px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-lg-bg'), ")"),
        height: '384px'
      });
      break;

    case 'xl':
      $('.hero-bg').css({
        'background-image': "url(".concat($('.hero-bg').attr('data-lg-bg'), ")"),
        height: '360px'
      });
      $('.hero-bg-full-w').css({
        'background-image': "url(".concat($('.hero-bg-full-w').attr('data-lg-bg'), ")"),
        height: '460px'
      });
      break;

    default:
      break;
  }

  $('.hero').ready(configureHeroBG);
  mediator.on('window:throttledResize', configureHeroBG);
};
export default (function () {
  initialHeroBG();
});